import React from 'react';
import Link from 'next/link';
import { BlogPost } from './blogPosts';

export const BlogPostTagsView: React.FC<{ post: BlogPost }> = ({ post }) => {
  return (
    <div className="blog-post-tags">
      {post.attributes.blogPostTags.data.map((tag) => (
        <Link key={tag.id} href={`/blog?tag=${tag.attributes.name}`} passHref>
          <a>{`#${tag.attributes.name} `}</a>
        </Link>
      ))}
    </div>
  );
};
